import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d51b1eb8 = () => interopDefault(import('..\\pages\\bridge\\index.vue' /* webpackChunkName: "pages_bridge_index" */))
const _580f4c59 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _3fb37ec4 = () => interopDefault(import('..\\pages\\enrollment\\eligibility.vue' /* webpackChunkName: "pages_enrollment_eligibility" */))
const _24b48a02 = () => interopDefault(import('..\\pages\\enrollment\\error.vue' /* webpackChunkName: "pages_enrollment_error" */))
const _63174500 = () => interopDefault(import('..\\pages\\enrollment\\rejection.vue' /* webpackChunkName: "pages_enrollment_rejection" */))
const _53b397ba = () => interopDefault(import('..\\pages\\enrollment\\success.vue' /* webpackChunkName: "pages_enrollment_success" */))
const _61726e38 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _61563f36 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _611de132 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _6101b230 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _042d0425 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _7133224d = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/bridge",
    component: _d51b1eb8,
    name: "bridge"
  }, {
    path: "/unlock",
    component: _580f4c59,
    name: "unlock"
  }, {
    path: "/enrollment/eligibility",
    component: _3fb37ec4,
    name: "enrollment-eligibility"
  }, {
    path: "/enrollment/error",
    component: _24b48a02,
    name: "enrollment-error"
  }, {
    path: "/enrollment/rejection",
    component: _63174500,
    name: "enrollment-rejection"
  }, {
    path: "/enrollment/success",
    component: _53b397ba,
    name: "enrollment-success"
  }, {
    path: "/errors/400",
    component: _61726e38,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _61563f36,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _611de132,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _6101b230,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _042d0425,
    name: "errors-500"
  }, {
    path: "/",
    component: _7133224d,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
